module.exports = __webpack_public_path__ + "static/media/06-chs.5a534de3.png";